import { useEffect } from 'react';
import { useCompanyProfileSettings } from '@/hooks/useSettings';
import { useAuthStore } from '@/store/authStore';
import { setCompanyLetterheadFromSettings } from '@/print-engine/company-letterhead';

/** Keeps the print letterhead in step with the signed-in company's settings (including after a company switch or save). */
export function CompanyLetterheadSync(): null {
  const companyId = useAuthStore((s) => s.user?.company_id);
  const { data } = useCompanyProfileSettings(companyId);
  useEffect(() => {
    setCompanyLetterheadFromSettings(companyId ? data : null);
  }, [companyId, data]);
  return null;
}
